"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SttText = _interopRequireDefault(require("../../../SttTypography/SttText"));
var _SttButton = _interopRequireDefault(require("../../../SttButton/SttButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ConteudoToolTip = function ConteudoToolTip(_ref) {
  var _ref$atendenteOnline = _ref.atendenteOnline,
    atendenteOnline = _ref$atendenteOnline === void 0 ? false : _ref$atendenteOnline,
    _ref$urlHelpdesk = _ref.urlHelpdesk,
    urlHelpdesk = _ref$urlHelpdesk === void 0 ? null : _ref$urlHelpdesk;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SttText["default"], {
    color: "primary",
    variant: "h1",
    style: {
      marginTop: '6px'
    }
  }, /*#__PURE__*/_react["default"].createElement("strong", null, "O que voc\xEA deseja?")), /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
    type: "button",
    variant: "contained",
    size: "small",
    nomarginleft: "true",
    fullWidth: true,
    style: {
      borderRadius: '20px',
      marginTop: '20px',
      backgroundColor: '#0a6fb8'
    },
    onClick: function onClick() {
      return window.parent.postMessage({
        "acao": "ABRIR_MATERIAL_SUPORTE"
      }, "*");
    },
    color: "primary"
  }, "Material de Apoio"), /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
    type: "button",
    size: "small",
    fullWidth: true,
    nomarginleft: "true",
    variant: "contained",
    style: {
      borderRadius: '20px',
      marginTop: '10px',
      backgroundColor: atendenteOnline ? '#0a6fb8' : ''
    },
    onClick: function onClick() {
      return window.open(urlHelpdesk, '_blank');
    },
    disabled: !atendenteOnline || !urlHelpdesk,
    color: "primary"
  }, "Atendimento"));
};
var _default = ConteudoToolTip;
exports["default"] = _default;